import { render, staticRenderFns } from "./layoutSidebarItem.vue?vue&type=template&id=0d07061b&"
import script from "./layoutSidebarItem.vue?vue&type=script&lang=js&"
export * from "./layoutSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports